export const environment = {
    production: false,
    qa: true,
    apiUrl: 'https://qaapi.assisthemis.com.br'
};
